<template>
  <auth-template>
    <b-col md="5">
      <b-card-group>
        <b-card no-body class="p-4">
          <b-card-body>
            <b-form>
              <b-row>
                <b-col cols="12">
                  <img src="../../assets/logo-maesdobrasil.e3480dd.png" style="width: 80%; margin-left: 10%;"/>
                </b-col>
              </b-row>
              <p style="text-align: center; padding-top: 30px; padding-bottom: 30px; ">Acione o botão abaixo para realizar a sua autenticação na plataforma <strong>Mães do Brasil.</strong></p>
              <b-row>
                <b-col sm="12">
                  <b-button block variant="secondary" @click="govbr" class="btn-gov">
                    <span>Entrar com <strong>Gov.BR</strong></span>
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-card-group>
    </b-col>
  </auth-template>
</template>

<script>
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import gRecaptcha from './recaptcha'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'

export default {
  name: 'Login',
  components: {
    AuthTemplate,
    gRecaptcha
  },
  data () {
    return {
      usuario: {
        cpf: '',
        senha: ''
      },
      logando: false,
      titulo_toast: 'Alerta!',
      chavaCaptcha: process.env.KEY_RECAPTCHA
    }
  },
  methods: {
    navigate (route) {
      this.$router.push(route)
    },
    govbr () {
      Vue.http.get('api/auth/login/uri').then(response => {
        let url = response.body.data.url
        location.href = url
      }).catch(e => {})
    }
  }
}
</script>

<style scoped>
.recaptchaBox {
  margin-bottom: 20px;
}

.btn-gov {
  height: 150%;
  border-radius: 46px;
  color: #fff;
  background: #1351b4;
  background-color: #1351b4 !important;
  font-family: Rawline,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
}
</style>



// WEBPACK FOOTER //
// src/pages/auth/Login.vue